// extracted by mini-css-extract-plugin
module.exports = {"container":"About_container__3bN0l","titleContainer":"About_titleContainer__12h-H","title":"About_title__2q7IW"};